<template>
  <div class="columns footer">
    <div class="column footercolumn">
      <router-link :to="'/'">
        <span class="footer-logo">
          <span class="secundary-color">vanhoutte</span>
          <span>jp</span>
        </span>
      </router-link>
    </div>
    <div class="column footercolumn">
      <router-link :to="'/privacy-policy/'">
        {{ $t('Footer.Policy') }}
      </router-link>
    </div>
    <div class="column footercolumn">
      <router-link :to="'/disclaimer/'">
        {{ $t('Footer.Disclaimer') }}
      </router-link>
    </div>
    <div class="column footercolumn">
      <router-link :to="'/conditions/'">
        {{ $t('Footer.Conditions') }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
};

</script>

<style scoped lang="scss">
@import "../assets/css/style.scss";
.footer {
  margin: 40px 0px 0px;
  padding: 0px;
  border-top: 1px solid $primary;
}
.footercolumn {
  text-align: center;
  margin: 20px, 0px;
}
.secundary-color {
  color: $secundary;
}
.footer-logo {
  text-transform: uppercase;
  font-weight: 800;
}
span {
  font-family: Nunito;
}
</style>
